var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeLightIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 391.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#a07e60;}.cls-3{fill:#edb48e;}.cls-4{fill:#4c453c;}.cls-5{fill:#3f3a34;}.cls-6{fill:#876d51;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,231.39C517.13,229,318.89,22.94,311,14.61c-8.55-8.95-19.88-4.84-20.09-4.76.1,0,.66-.27-9.53,2.65-10.79,3.08-14.29-.8-14.29-.8s-4-5.24-17.63-1.29C233.58,15,7.86,72.35,7.86,72.35S.77,74.17.69,81.43,0,126.19,0,126.19,195.25,377.57,202.91,387.53c6.27,8.2,22,2.49,22,2.49S509,287,515.64,284.61C521.45,282.12,521,277,521,277l.13-37.91S521.36,233.5,519.39,231.39Zm-98.52-59.13-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L422.71,165C425.35,167.78,424.53,171.06,420.87,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M482.21,185.58c-1.89-2-167.09-173.72-173.71-180.65-7.11-7.46-16.56-4-16.74-4,.08,0,.55-.23-7.94,2.2-9,2.58-11.91-.66-11.91-.66s-3.29-4.36-14.69-1.07C244,5.24,55.93,53,55.93,53S50,54.56,50,60.61s-.58,37.3-.58,37.3S212.09,307.39,218.47,315.69c5.23,6.83,18.36,2.08,18.36,2.08S473.56,232,479.08,229.92c4.84-2.07,4.5-6.38,4.5-6.38l.1-31.59S483.85,187.34,482.21,185.58Zm-61.34-13.32-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L422.71,165C425.35,167.78,424.53,171.06,420.87,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M479.59,182.73S315.12,11.75,308.5,4.81c-7.11-7.46-16.56-4-16.74-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.91-.66-11.91-.66S268.62-2,257.22,1.31C244,5.12,55.93,52.93,55.93,52.93s-8.71,3-3.6,9.42C57.7,69.4,100.93,126,100.93,126s107.5,135.24,115.55,145.29,23.12,3.88,23.12,3.88,227.06-77.39,237.78-81S479.59,182.73,479.59,182.73Zm-58.72-10.47-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L422.71,165C425.35,167.78,424.53,171.06,420.87,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "241.29 281.15 241.29 308.67 474.1 224.48 474.1 201.17 241.29 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "474.1 201.17 457.76 206.84 474.1 224.48 474.1 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.63,128.13l-7.76,1.57c17.27,21.72,105.36,132.53,112.61,141.59A15.61,15.61,0,0,0,228.23,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M479.59,182.73S409.06,109.41,358.52,56.84l-4.08,1.74L481.85,191.4C484.88,187.58,479.59,182.73,479.59,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.17,58.53c-8.48,2.19-26.72,8.67-16.64,21.56S124.46,93.35,142,88.52s132.73-36.46,143.9-39.6,25.7-9.77,12.89-21.8S268.33,18.41,254,22.2,124.65,56.33,116.17,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.58,13.22l-2-2-25.09,6.74a30.56,30.56,0,0,1,3.68,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92,70.72,64.27,78.07l1.92,2.51L92,73.67A9.15,9.15,0,0,1,92,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.79,17.6l-2-2-22.27,6A28.92,28.92,0,0,1,299,23.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M67.78,82.62l1.93,2.5,24.23-6.47A17.48,17.48,0,0,1,92.65,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.12,27.77l21.75-5.92-1.94-2-21.6,5.86c.32.33.63.67.94,1S302.85,27.42,303.12,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.76,81.29,71.69,87.8l1.94,2.49L97.77,83.7c-.48-.53-1-1.08-1.42-1.65C96.13,81.79,96,81.54,95.76,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.41,92.56l1.94,2.49,25.17-6.89c-.87-.69-1.73-1.44-2.59-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329,26.1l-1.94-2-22.24,6.05A17,17,0,0,1,306,32.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.61,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306.76,37.37l26.16-7.16-1.93-2-24.31,6.61A8.81,8.81,0,0,1,306.76,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M428.82,165.28,329.21,59.9a16.45,16.45,0,0,0-14.85-4.11l-183.54,51.5c-4.76,1.34-6.12,5.59-3,9.44l94.32,117.15a14,14,0,0,0,14.19,4.17l190.15-63.39C431.16,173.1,432.22,168.87,428.82,165.28Zm-7.95,7-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L422.71,165C425.35,167.78,424.53,171.06,420.87,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.64,217.59c-3.12-1.08-3.11-2.79,0-3.82l22.32-7.3c3.13-1,5.27.8,4.74,4.06l-1.55,9.58a4.9,4.9,0,0,1-6.63,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeLightIsometric);
export default __webpack_public_path__ + "static/media/orange-light-isometric.e628f9fecb413fb95ad4c7c5656d045d.svg";
export { ForwardRef as ReactComponent };